<template>
    <div @click="$emit('click')" class="kv-chip" :class="[densityClass, roundedClass, variantClass, sizeClass, colorClass]" :style="chipStyle">
        <Icon v-if="prependIcon" :icon-class="prependIcon" :size="calculatedIconSize" />
        <slot></slot>
    </div>
</template>

<script>
import Icon from '@/components/icon/icon.vue';

export default {
    name: "KvChip",
    components: {
        Icon
    },
    props: {
        variant: {
            type: String,
            default: "tonal",
        },
        size: {
            type: String,
            default: "regular",
        },
        color: {
            type: String,
            default: "default",
        },
        rounded: {
            type: String,
            default: 'default', // default | soft | pill
        },
        density: {
            type: String,
            default: 'default', // default | compact
        },
        colors: {
            type: Object,
            default: () => ({})
        },
        prependIcon: {
            type: String,
            default: null,
        },
        iconSize: [String, Number],
    },
    computed: {
        variantClass() {
            return `kv-${this.variant}-chip`;
        },
        sizeClass() {
            return `kv-${this.size}-chip`;
        },
        colorClass() {
            return `kv-${this.color}-chip`;
        },
        roundedClass() {
            return `kv-rounded-${this.rounded}`;
        },
        densityClass() {
            return `kv-density-${this.density}`;
        },
        chipStyle() {
            const style = {};

            if (this.colors.background) style.backgroundColor = this.colors.background;
            if (this.colors.border) style.borderColor = this.colors.border;
            if (this.colors.text) style.color = this.colors.text;

            return style;
        },
        calculatedIconSize() {
            // Se o dev passou manualmente, respeita o valor
            if (this.iconSize) return this.iconSize;

            // Caso contrário, define automático
            switch (this.size) {
                case "small":
                    return 1;
                case "large":
                    return 4;
                default:
                    return 2;
            }
        },
    }
};
</script>

<style lang="less">
.kv-chip {
    border-radius: 24px;
    padding: 6px 10px;
    font-weight: 500;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    /* density */
    &.kv-density-compact {
        padding: 4px 8px;
    }

    &.kv-density-extra-compact {
        padding: 2px 6px;
    }

    &.kv-rounded-medium {
        border-radius: 8px;
    }

    &.kv-rounded-soft {
        border-radius: 4px;
    }

    &.kv-rounded-pill {
        border-radius: 9999px;
    }

    &.kv-success-chip {
        color: #0B9055;
        background-color: #D3F8E0;
    }

    &.kv-warning-chip {
        color: #F79009;
        background-color: #FFF7D4;
    }

    &.kv-error-chip {
        color: #F04438;
        background-color: #FEE4E2;
    }

    &.kv-primary-chip {
        color: #0B9055;
        background-color: #EDFCF3;
    }

    &.kv-default-chip {
        color: #384250;
        background-color: #E5E7EB;
    }

    &.kv-muted-chip {
        color: #9DA4AE;
        background-color: #E5E7EB;
    }

}
</style>
